import { render, staticRenderFns } from "./biaozhunchaxun.vue?vue&type=template&id=62e96b36&scoped=true"
import script from "./biaozhunchaxun.vue?vue&type=script&lang=js"
export * from "./biaozhunchaxun.vue?vue&type=script&lang=js"
import style0 from "./biaozhunchaxun.vue?vue&type=style&index=0&id=62e96b36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e96b36",
  null
  
)

export default component.exports